import { render, staticRenderFns } from "./StandardSuccess.vue?vue&type=template&id=5fa85389&scoped=true&"
import script from "./StandardSuccess.js?vue&type=script&lang=js&"
export * from "./StandardSuccess.js?vue&type=script&lang=js&"
import style0 from "./StandardSuccess.vue?vue&type=style&index=0&id=5fa85389&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa85389",
  null
  
)

export default component.exports